import { DiceD6OutlineIcon } from './DiceD6OutlineIcon';

/**
 * author: Austin Andrews
 * id A0F00FDF-6648-475B-819B-29E4C0769FFA
 * name dice-d6-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dice-d6-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const DieD6Icon = DiceD6OutlineIcon;
export default DieD6Icon